import { toast } from 'vue-sonner';
import { i18n } from '@/i18n';

function translate(message: string): string {
  return i18n.global.te(message) ? String(i18n.global.t(message)) : message;
}

type NotifyOptions = {
  description?: string;
  duration?: number;
};

export const notifier = {
  success(message: string, options?: NotifyOptions) {
    toast.success(translate(message), notifyOptions(options));
  },
  error(message: string, options?: NotifyOptions) {
    toast.error(translate(message), notifyOptions(options));
  },
  info(message: string, options?: NotifyOptions) {
    toast.info(translate(message), notifyOptions(options));
  },
  warning(message: string, options?: NotifyOptions) {
    toast.warning(translate(message), notifyOptions(options));
  },
};

function notifyOptions(options?: NotifyOptions) {
  if (!options?.description && options?.duration == null) {
    return undefined;
  }
  return {
    description: options.description,
    duration: options.duration ?? (options.description ? 8000 : undefined),
  };
}
